import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';

/**
 * Renders children into document.body so position:fixed overlays escape any ancestor
 * that creates a containing block (backdrop-filter / filter / transform on holo panels and header).
 */
export default function BodyPortal({ children }: { children: ReactNode }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
